module.exports = __webpack_public_path__ + "img/visitor.b7522b1a.jpg";